<template>
    <v-dialog scrollable style="z-index:1000">
        <template v-slot:activator="{on}">
            <slot name="activator" :on="on"></slot>
        </template>
        <v-card style="z-index:1001">
            <v-card-title>Tools</v-card-title>
            <v-card-text>
                <v-row justify="space-around">
                    <v-col cols="3">
                        <v-card outlined>
                            <v-card-title>Vehicles</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-simple-table>
                                  <thead>
                                    <tr>
                                      <th>Color</th>
                                      <th>Maker</th>
                                      <th>Model</th>
                                      <th>Owner</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                  <tr>
                                    <td>Devin Hines</td>
                                    <td>White</td>
                                    <td>Honda</td>
                                    <td>Civic</td>
                                  </tr>
                                  </tbody>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="3">
                        <v-card outlined>
                            <v-card-title>Routes</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-simple-table>
                                  <thead>
                                    <tr>
                                      <th>Name</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(route, index) in routes">
                                      <td>{{route.name}}</td>
                                    </tr>
                                  </tbody>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="3">
                        <v-card outlined>
                            <v-card-title>Update Customer LatLon</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-autocomplete label="Select Customer" :items="names.filter(name => name.name_type_id === 1)" item-text="name"></v-autocomplete>
                                <v-text-field label="Lat(optional)"></v-text-field>
                                <v-text-field label="Lon(optional)"></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn @click="$store.dispatch('showSuccess', 'Updated Customer & Scheduled Routes')" block>submit</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "Tools",
        props: {
          routes: {
            required: true,
          },
          names: {
            required: true,
          }
        }
    }
</script>

<style scoped>

</style>
